module.exports = __webpack_public_path__ + "img/2.65f0dc00.jpg";